export const flashBarTheme = { SUCCESS: 'success', ERROR: 'error', INFO: 'info' };
